import { __extends } from "tslib";
export var TypeErrors;
(function (TypeErrors) {
    TypeErrors["RolePermission"] = "api.context.permissions.app_error";
    TypeErrors["LicencePermission"] = "api.context.permissions.license";
    TypeErrors["PauseNotAllow"] = "app.agent.set_pause.not_allow";
})(TypeErrors || (TypeErrors = {}));
var DeviceNotFoundError = /** @class */ (function (_super) {
    __extends(DeviceNotFoundError, _super);
    function DeviceNotFoundError(msg) {
        var _this = _super.call(this, msg) || this;
        _this.id = DeviceNotFoundError.id;
        return _this;
    }
    DeviceNotFoundError.id = "device_not_found";
    return DeviceNotFoundError;
}(Error));
export { DeviceNotFoundError };
// tslint:disable-next-line: max-classes-per-file
var DeviceNotAllowPermissionError = /** @class */ (function (_super) {
    __extends(DeviceNotAllowPermissionError, _super);
    function DeviceNotAllowPermissionError(msg) {
        var _this = _super.call(this, msg) || this;
        _this.id = DeviceNotAllowPermissionError.id;
        return _this;
    }
    DeviceNotAllowPermissionError.id = "device_not_allow";
    return DeviceNotAllowPermissionError;
}(Error));
export { DeviceNotAllowPermissionError };
// tslint:disable-next-line: max-classes-per-file
var RolePermissionError = /** @class */ (function (_super) {
    __extends(RolePermissionError, _super);
    function RolePermissionError(msg) {
        var _this = _super.call(this, msg) || this;
        _this.id = RolePermissionError.id;
        return _this;
    }
    RolePermissionError.id = TypeErrors.RolePermission;
    return RolePermissionError;
}(Error));
export { RolePermissionError };
// tslint:disable-next-line: max-classes-per-file
var LicencePermissionError = /** @class */ (function (_super) {
    __extends(LicencePermissionError, _super);
    function LicencePermissionError(msg) {
        var _this = _super.call(this, msg) || this;
        _this.id = LicencePermissionError.id;
        return _this;
    }
    LicencePermissionError.id = TypeErrors.LicencePermission;
    return LicencePermissionError;
}(Error));
export { LicencePermissionError };
// tslint:disable-next-line: max-classes-per-file
var PauseNotAllowedError = /** @class */ (function (_super) {
    __extends(PauseNotAllowedError, _super);
    function PauseNotAllowedError(msg) {
        var _this = _super.call(this, msg) || this;
        _this.id = PauseNotAllowedError.id;
        return _this;
    }
    PauseNotAllowedError.id = TypeErrors.PauseNotAllow;
    return PauseNotAllowedError;
}(Error));
export { PauseNotAllowedError };
//# sourceMappingURL=errors.js.map